

export const IbAnonymousInitialValue = {
    appUserInfo: {
        userType: 'ANONYMOUS',
        logged: false
    }
} as const;